import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import { Fade } from "react-awesome-reveal";
import Pagination from '../../components/Pagination';
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from 'swiper/react';
import { isMobileDevice } from "../../utils";
import { useLocation, useNavigate } from "react-router";
import { addCart, productConceptPage, productPage, productTypeList } from "../../API";
import { getQueryParam } from "../../utils/getUrlParamsLegacy";
import { message } from "antd";

const ComponentName: React.FC = () => {
  const [swiperRef, setSwiperRef]: any = useState(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const { t } = useTranslation();
  const [showCategory, setShowCategory] = React.useState(false);
  const [pageIndex, setPageIndex] = React.useState(1);
  const navigate = useNavigate()

  const [tabIndex, setTabIndex] = React.useState(0)
  const [categoryLi, setCategoryLi] = React.useState<any>([])
  const handleLoad = () => {
    productTypeList()
      .then((res) => {
        setCategoryLi(res.data)

        const tab = getQueryParam('id')
        if (tab && tabIndex === 0) {
          const index = res.data.findIndex((item: any) => Number(item.id) === Number(tab))
          if (index !== -1) {
            setTabIndex(index)
          }
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const [pageSize, setPageSize] = React.useState(20)
  const [totalPages, setTotalPages] = React.useState(0)
  const [productList, setProductList] = React.useState<any>([])
  const handleproductPage = (page: number) => {
    productPage({
      "pageNum": page,
      "pageSize": pageSize,
      "params": {
        "title": "",
        "cfgCode": categoryLi[tabIndex]?.cfgGroupSort
      }
    }).then((res) => {
      setProductList(res.data.records)
      setTotalPages(res.data.total)
    }).catch((err) => {
      console.log(err)
    })
  }
  const { pathname, search } = useLocation();
  useEffect(() => {
    handleLoad()
    handleproductPage(pageIndex)
  }, [pageIndex, tabIndex])


  const handleaddCart = (item: any) => {
    addCart({
      productId: item?.id,
      productNum: 1
    }).then((res: any) => {
      console.log(res)
      message.success('加入購物車成功')
    }).catch((err: any) => {
      console.log(err)
    })
  }

  const [list, setList] = React.useState<any>()
  const handleLoadProductConceptPage = () => {
    productConceptPage({
      "pageNum": 1,
      "pageSize": 3,
    }).then(res => {
      setList((res.data?.records || []).slice(0, 3))
    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    handleLoadProductConceptPage()
  }, [])

  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">{categoryLi[tabIndex]?.cfgName}</div>
        </div>
        <br />
        <div className="text-[#3c342e] text-[46px] font-bold mb-[30px] text-center h5:text-[30px] h5:mb-[15px]">{categoryLi[tabIndex]?.cfgName}</div>
        <div className="pb-[75px]">
          <div className="text-[#595959] text-[18px] w-[770px] mx-auto text-center h5:w-full h5:px-[16px] h5:text-center h5:text-[16px]">
            {categoryLi[tabIndex]?.cfgDesc}
          </div>
        </div>
        <div className=" mb-[75px] h5:mb-[15px]">
          <div className="flex items-center pb-[15px] h5:mx-[16px] "
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, .2)"
            }}> 
            {
              categoryLi.map((item: any, index: number) => {
                return <div
                  key={index}
                  className="flex-1 text-center text-[20px] hover:text-[#181512] cursor-pointer h5:text-left h5:text-[17px]"
                  style={{ 
                    display: (index !== 0 && isMobileDevice()) ? 'none' : 'block',
                    color: tabIndex === index ? '#181512' : '#595959',
                    fontWeight: tabIndex === index ? 'bold' : 'normal'
                  }}
                  onClick={() => {
                    if (item?.cfgGroupSort === 0) {
                      navigate('/category')
                      window.location.reload()
                      return
                    }
                    setTabIndex(index)
                  }
                  }
                >
                  {item?.cfgName}
                </div>
              })
            } 
            <img src={require('../../assets/image/icon19.png')}
              alt=""
              onClick={() => {
                setShowCategory(!showCategory)
              }}
              className="w-[16px]" />
          </div>

          <div className={`${showCategory ? 'block' : 'hidden'} mt-[15px]`}>
            {
              categoryLi.map((item: any, index: number) => {
                return <div
                  key={index} className="flex items-center pb-[15px] mb-[15px] h5:mx-[16px]"

                  onClick={() => {
                    setTabIndex(index)
                  }
                  }
                  style={{
                    color: tabIndex === index ? '#181512' : '#595959',
                    fontWeight: tabIndex === index ? 'bold' : 'normal',

                    borderBottom: "1px solid rgba(0, 0, 0, .2)"
                  }} >
                  {item?.cfgName}
                </div>
              })
            }
            {/* <div className="flex items-center pb-[15px] mb-[15px] h5:mx-[16px]"
              style={{
                borderBottom: "1px solid rgba(0, 0, 0, .2)"
              }}>設計師系列</div> */}
          </div>
        </div>

        <div className="grid gap-[30px] grid-cols-1 md:grid-cols-4 h5:pt-15">
          {
            productList.map((item: any, index: number) => (
              <Fade key={index} cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
                <div className="pb-[80px] cursor-pointer h5:px-[60px] h5:pb-20"
                  onClick={() => { 
                    navigate(`/product?id=${item?.id}&category=${categoryLi[tabIndex]?.cfgName}`)
                  }}>
                  <div className="p-[15px] rounded-[4px]"
                    style={{
                      border: "1px solid rgba(0, 0, 0, .1)"
                    }}>
                    <img src={item?.imageUrl} alt=""
                      className='w-full rounded-[4px] object-contain' />
                  </div>
                  <div className="text-[#181512] text-[20px] text-center mt-20 mb-18  line-clamp-1">{item?.title}</div>
                  <div className="text-[#595959] text-[18px] text-center  line-clamp-1">{item?.size}</div>
                  <div className="flex items-center justify-center mt-18 mb-20">
                    <div className="text-[#888] text-[18px]">USD</div>
                    <div className="text-[#888] text-[18px]">{item?.originalPrice}</div>
                    <div className="text-[#888] text-[18px] font-bold ml-4"> USD</div>
                    <div className="text-[#888] text-[18px] font-bold">{item?.currentPrice}</div>
                  </div>
                  <div className="bg-[#6d6e71] rounded-[4px] flex items-center justify-center py-[18px] text-[#fff] text-[18px] cursor-pointer
                        hover:bg-[#000]"
                    onClick={(e) => {
                      // e.stopPropagation();
                      // handleaddCart(item)
                    }}>
                    <img src={require("../../assets/image/icon3_1.png")} className='w-[26px] mr-4' alt="" />
                    查看詳情
                  </div>
                </div>
              </Fade>
            ))
          }
        </div>
        <div className="flex justify-center pb-[75px]"> 
          {
            Math.ceil(totalPages / pageSize) > 1 ?
          <Pagination
            totalPages={Math.ceil(totalPages / pageSize)}
                currentPage={pageIndex}
            onPageChange={(page: number) => setPageIndex(page)}
              /> : ''
          }
        </div>
      </div>

      <div className="relative pb-[100px]">
        <div className="text-[#3c342e] text-[30px] font-bold mb-[30px] text-center h5:text-[25px] h5:mb-[15px]">尋找靈感</div>
        <div className='w-[1200px] mx-auto relative mt-[30px] h5:w-full'>
          <Swiper
            slidesPerView={isMobileDevice() ? 1 : 3}
            autoplay={{
              delay: 100000,
              // disableOnInteraction: false,
            }}
            loop={false}
            modules={[Autoplay, Pagination]}
            pagination={{
              clickable: true,  // 使指示点可点击
              bulletClass: 'swiper-pagination-bullet2',  // 指示点的类名
              bulletActiveClass: 'swiper-pagination-bullet-active2',  // 活动指示点的类名
            }}
            ref={swiperRef}
            onSwiper={setSwiperRef}
            onSlideChange={(swiper: any) => {
              setSwiperIndex(swiper.activeIndex);
            }}
          >
            {
              list && list.map((item: any, index: any) => (
                <SwiperSlide key={index}>
                  <Fade cascade={true} direction="down" delay={0} duration={600} triggerOnce={true}>
                    <div className="px-[15px] cursor-pointer h5:px-[36px] h5:pb-20"
                      onClick={() => {
                        navigate('/exhibit/detail?id=' + item?.id)
                      }}>
                      <img src={item?.showImgUrl} alt=""
                        className='w-full h-[460px] object-cover' />
                      <div className="text-[#181512] text-[22px] font-bold text-center my-[30px]">{item?.title}</div>
                    </div>
                  </Fade>
                </ SwiperSlide>
              ))
            }
          </Swiper>
          <div className={`block`}>
            <div className={`${swiperIndex === 0 ? 'opacity-20' : 'opacity-60'}   absolute top-[46%] left-[-30px] z-[10] h5:left-[10px]`}
              onClick={() => {
                swiperRef.slideTo(swiperIndex === 0 ? 0 : swiperIndex - 1);
              }}>
              <img src={require('../../assets/image/icon1.png')} alt=""
                className='w-[30px] cursor-pointer rotate-[180deg] h5:w-[20px]'
              />
            </div>
            <div className={`${swiperIndex === 2 ? 'opacity-20' : 'opacity-60'} absolute top-[46%] right-[-30px] z-[10] h5:right-[10px]`}
              onClick={() => {
                swiperRef.slideTo(swiperIndex === 2 ? 2 : swiperIndex + 1);
              }}>
              <img src={require('../../assets/image/icon1.png')} alt=""
                className='w-[30px] cursor-pointer rotate-[0deg] h5:w-[20px]'
              />
            </div>
          </div>
        </div>
        <img src={require("../../assets/image/icon7.png")}
          className='absolute left-0 top-[220px] w-[100%] h-[540px] z-[-1]
          h5:w-[100%] h5:top-auto h5:bottom-[0px]
          '
          alt="" />
      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
